import React from "react";

import { useSelector } from "react-redux";
import type { RootState } from "web/store";

import * as dateish from "js/dateish";

import SpeciesTable from "web/ui/species_table";
import { dateishURL } from "web/ui/date_link";
import { useDatabase } from "web/hooks";

import classes from './dateish_page.module.css';
import NextPrev from "web/ui/next_prev";
import NeedsList from "web/ui/needs_list";

const DateishPage = ({ date }: { date: dateish.Any }) => {
  const database = useDatabase();
  const needsRegion = useSelector((state: RootState) => state.app.currentRegion);

  // TODO: Forward adds day of months that don't exist for short months
  return <div className={ classes.root }>
    <div className={ classes.header }>
      <NextPrev
        next={ dateishURL(dateish.anyNext(date)) }
        prev={ dateishURL(dateish.anyPrev(date)) }>
        <h2>{ dateish.anyDisplay(date) }</h2>
      </NextPrev>
    </div>
    {/* <ObservationTable query={ store.doySpecies.bind(store, date) } /> */}
    <SpeciesTable query={ database.dateishSpeciesTable.bind(database, date) } args={ date } />
    { needsRegion && <div>{ `NEEDS: ${needsRegion.name} (${needsRegion.code})` }</div> }
    <NeedsList date={ date } />
  </div>;
}

export default DateishPage;
